<template>
  <!--footer 开始-->
  <footer class="site-footer">
    <!-- 主要内容区域 -->
    <div class="footer-main">
      <div class="footer-container">
        <!-- 协会信息 -->
        <div class="footer-info">
          <div class="info-left">
            <!-- 相关链接 -->
            <div class="footer-links">
              <span class="links-label">相关链接</span>
              <div class="links-list">
                <a v-for="(link, index) in friendLinks" :key="index" :href="link.url" target="_blank" class="link-item">
                  {{ link.name }}
                </a>
              </div>
            </div>

            <h2 class="footer-title">山东省心理咨询行业协会</h2>
            <p class="footer-title-en">Shandong Association of Psychological Counseling</p>
            <div class="contact-info">
              <p><span class="label">电话：</span>0537-3616866</p>
              <p><span class="label">地址：</span>山东省济宁市建设南路45号济宁医学院任城校区3号楼</p>
            </div>
          </div>
          <div class="info-right">
            <div class="qrcode-box">
              <img :src="qrcodeImg" alt="关注公众号" class="qrcode-img">
              <span class="qrcode-text">关注公众号</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="footer-copyright">
      <div class="footer-container">
        <p>Copyright © {{ currentYear }} 山东省心理咨询行业协会 All Rights Reserved.</p>
        <p>
          ICP备案号：<a href="https://beian.miit.gov.cn" target="_blank" title="鲁ICP备2021032718号">鲁ICP备2021032718号</a>
        </p>
        <p class="gongan-beian">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37081102000794" target="_blank" title="鲁公网安备37081102000794">
            <img :src="ghIcon" alt="公安备案" class="gongan-icon" />
            鲁公网安备37081102000794号
          </a>
        </p>
      </div>
    </div>
  </footer>
  <!--footer 结束-->

  <!-- 返回顶部 -->
  <div class="back-top" @click="scrollToTop" v-show="showBackToTop">
    <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
      <path d="M12 4l-8 8h5v8h6v-8h5z" />
    </svg>
    <span>回到顶部</span>
  </div>
</template>

<script>
import sys from "@/api/system";

export default {
  name: 'SiteFooter',
  props: {
    auth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      qrcodeImg: require('@/assets/images/qrcode.jpg'),
      ghIcon: require('@/assets/images/gh.jpg'),
      friendLinks: [
        { name: '济宁医学院', url: 'https://www.jnmc.edu.cn' },
        { name: '省心理协会', url: '#' },
        { name: '济宁任城心理医院', url: '#' },
        { name: '智善儿童康复医院', url: '#' },
        { name: '济南智善心理', url: '#' }
      ],
      config_base: {},
      config_company: {},
      showBackToTop: false
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  created() {
    this.getConfig();
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 获取配置
    getConfig() {
      sys.getConfig({
        param: 'no'
      }).then(res => {
        if (res && res.data) {
          this.config_base = res.data.base || {};
          this.config_company = res.data.company || {};
          if (this.config_company.company_wechat) {
            this.qrcodeImg = this.config_company.company_wechat;
          }
        }
      }).catch(() => {
        // 使用默认配置
      });
    },
    // 返回顶部
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    // 监听滚动
    handleScroll() {
      this.showBackToTop = window.scrollY > 200;
    }
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  width: 100%;
  background: #1e9dd4;
}

.footer-container {
  width: 1400px;
  margin: 0 auto;
}

/* 主要内容区域 */
.footer-main {
  padding: 25px 0 20px;
}

/* 相关链接 */
.footer-links {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .links-label {
    color: #fff;
    font-size: 14px;
    margin-right: 15px;
    white-space: nowrap;
  }

  .links-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .link-item {
    display: inline-block;
    padding: 5px 14px;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 3px;
    color: #fff;
    font-size: 13px;
    text-decoration: none;
    transition: all 0.3s;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.6);
    }
  }
}

/* 协会信息 */
.footer-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.info-left {
  flex: 1;

  .footer-title {
    font-size: 22px;
    font-weight: bold;
    color: #fff;
    margin: 0 0 6px 0;
    letter-spacing: 1px;
  }

  .footer-title-en {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
    margin: 0 0 15px 0;
  }

  .contact-info {
    p {
      color: #fff;
      font-size: 13px;
      margin: 0 0 8px 0;
      line-height: 1.6;

      .label {
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }
}

.info-right {
  margin-left: 40px;

  .qrcode-box {
    text-align: center;

    .qrcode-img {
      width: 110px;
      height: 110px;
      background: #fff;
      padding: 6px;
      border-radius: 4px;
    }

    .qrcode-text {
      display: block;
      margin-top: 8px;
      color: #fff;
      font-size: 12px;
    }
  }
}

/* 版权信息 */
.footer-copyright {
  background: rgba(0, 0, 0, 0.15);
  padding: 12px 0;

  p {
    margin: 10px;
    text-align: center;
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;

    a {
      color: rgba(255, 255, 255, 0.85);
    }
  }

  .gongan-beian a {
    display: inline-flex;
    align-items: center;
    text-decoration: none;

    .gongan-icon {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
}

/* 返回顶部 */
.back-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  padding: 10px 0;
  background: #2b7cd0;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: background 0.3s;
  z-index: 999;

  svg {
    display: block;
    margin: 0 auto 5px;
  }

  span {
    display: block;
    font-size: 12px;
    line-height: 1.2;
  }

  &:hover {
    background: #1e6abc;
  }
}

/* 响应式 */
@media screen and (max-width: 1240px) {
  .footer-container {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 768px) {
  .footer-links {
    flex-direction: column;
    align-items: flex-start;

    .links-label {
      margin-bottom: 10px;
    }
  }

  .footer-info {
    flex-direction: column;

    .info-left {
      margin-bottom: 20px;
    }

    .info-right {
      align-self: flex-start;
    }
  }

  .info-left .footer-title {
    font-size: 20px;
  }
}
</style>
